import React, { useState, useContext, useEffect } from 'react';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import { DialogActions, Typography, Grid, Button, TextField, MenuItem, InputAdornment, OutlinedInput, InputLabel, InputBase } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import axios from 'axios';
import { DigitoVerificador } from 'App/Helpers/Genericos'
import { LayoutContext } from 'App/Layout/store'
import _ from 'underscore';

const styles = theme => ({
    table: {
        marginTop: 30,
    },
    gridContainer: {
        paddingRight: 30,
        marginTop: "0.1px"
    },
    borderRed: {
        borderStyle: "solid",
        marginTop: "0.1px",
        padding: 10,
        borderColor: "red"
    },
    labelPaddingTop: {
        paddingTop: "10px"
    }
});

function AgregarEditarLibro(props) {
    const { classes } = props;
    const [libro, setLibro] = useState({})
    const [guardando, setGuardando] = useState(false)
    const layoutContext = useContext(LayoutContext);

    useEffect(() => {
        setLibro(layoutContext.state.libro)
        setGuardando(false)
    }, [layoutContext.state.libro])

    /* useEffect(() => {

    }, []) */

    function guardaLibro() {
        setGuardando(true)
        axios.post("/api/Libro/AgregarOEditar", libro).then(o => {
            alert("Libro guardado exitosamente");
        }).catch(e => /*alert(e.response.data.Mensaje)*/{}).finally(() => layoutContext.dispatch({ type: "toggleLibro", libro:null }));
    }

    const content = libro && (
        <Grid container direction="column">
            <Grid item xs={12} sm>
                <Grid container spacing={0}>
                    <Grid item xs={4}>
                        <TextField select
                            variant="outlined"
                            label="Tipo de Operación"
                            fullWidth
                            value={libro.operacion || ""}
                            onChange={e => { setLibro({ ...libro, operacion: e.target.value }) }}
                            margin="normal"
                        >
                            <MenuItem value={"0"}>Venta</MenuItem>
                            <MenuItem value={"1"}>Compra</MenuItem>
                            <MenuItem value={"2"}>Boleta</MenuItem>
                            <MenuItem value={"3"}>Guía de Despacho</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField select
                            variant="outlined"
                            label="Tipo de Libro"
                            fullWidth
                            value={libro.libro || ""}
                            onChange={e => { setLibro({ ...libro, libro: e.target.value }) }}
                            margin="normal"
                        >
                            {!(libro.operacion >= 2) && <MenuItem value={"0"}>Mensual</MenuItem>}
                            <MenuItem value={"1"}>Especial</MenuItem>
                            {!(libro.operacion >= 2) && <MenuItem value={"2"}>Rectifica</MenuItem>}
                        </TextField>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField select
                            variant="outlined"
                            label="Tipo de Envío"
                            fullWidth
                            value={libro.envio || ""}
                            onChange={e => { setLibro({ ...libro, envio: e.target.value }) }}
                            margin="normal"
                            >
                            <MenuItem value={"0"}>Total</MenuItem>
                            <MenuItem value={"1"}>Parcial</MenuItem>
                            <MenuItem value={"2"}>Final</MenuItem>
                            <MenuItem value={"3"}>Ajuste</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            variant="outlined"
                            label="Año"
                            fullWidth
                            type="text"
                            inputProps={{ maxLength: 4 }}
                            value={libro.ano || ""}
                            onChange={e => { setLibro({ ...libro, ano: e.target.value }) }}
                            margin="normal"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            variant="outlined"
                            label="Mes"
                            type="text"
                            inputProps={{ maxLength: 2 }}
                            fullWidth
                            value={libro.mes || ""}
                            onChange={e => { setLibro({ ...libro, mes: e.target.value }) }}
                            margin="normal"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    const footer = (
        <DialogActions>
            <Button onClick={() => { layoutContext.dispatch({ type: "toggleLibro", libro:null }) }} color="primary">
                Cancelar
        </Button>
            <Button disabled={guardando} onClick={() => guardaLibro()} color="primary" autoFocus>
                Guardar
        </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={layoutContext.state.libro} onClose={() => layoutContext.dispatch({ type: "toggleLibro", libro:null })} closeButton title={_.isEmpty(layoutContext.state.libro) ? "Agregar libro" : "Editar libro"} content={content} footer={footer} fullWidth size="sm" />
        </div>
    );
}

export default withStyles(styles)(AgregarEditarLibro);